// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33QFz","title":"styles_title__27H3g"};